import { render, staticRenderFns } from "./LoginPageTitle.vue?vue&type=template&id=1be5ddbf&scoped=true&"
import script from "./LoginPageTitle.vue?vue&type=script&lang=ts&"
export * from "./LoginPageTitle.vue?vue&type=script&lang=ts&"
import style0 from "./LoginPageTitle.vue?vue&type=style&index=0&id=1be5ddbf&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5ddbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VSpacer})
